import { useQueryGetSummaryTrackedActivities } from 'api/queries/getSummaryTrackedActivities.query';

export const useMyTrackedActivitiesWidgetProvider = ({ projectId, contractId, latestVersionId, compareVersionId }) => {
    return {
        ui: {
            state: getState({ projectId, contractId, latestVersionId, compareVersionId }),
        },
        api: {
            getSummaryTrackedActivities: useQueryGetSummaryTrackedActivities(
                getSummaryTrackedActivitiesPayload({ projectId, contractId, latestVersionId, compareVersionId }),
            ),
        },
    };
};

const getSummaryTrackedActivitiesPayload = ({ projectId, contractId, latestVersionId, compareVersionId }) => ({
    projectId,
    contractId,
    latestVersionId,
    compareVersionId,
    filter: {
        filters: [],
    },
});

const getState = ({ projectId, contractId, latestVersionId, compareVersionId }) => {
    return {
        //project
        projectId,
        contractId,
        latestVersionId,
        compareVersionId,
    };
};
